const NotFound = () => {
    return (
      <img
        style={{ width: "100%" }}
        src="https://www.elegantthemes.com/blog/wp-content/uploads/2020/02/000-404.png"
        alt="Page Not Found"
      />
    );
  };
  
  export default NotFound;
  